import { Component, Input } from '@angular/core';

@Component({
  selector: 'user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent {
  @Input() userName: string;
  @Input() size: string;


  constructor() { }

  getCharAtName(name: string): string { 
    return name && name.charAt(0).toUpperCase()
  }

  getRandomColor(): string {
    const name = this.userName;
    if (['A', 'N', 'H', 'Q'].includes(this.getCharAtName(name))) return 'primary';
    if (['F', 'G', 'I', 'J'].includes(this.getCharAtName(name))) return 'info';
    if (['D', 'Y', 'B', 'O'].includes(this.getCharAtName(name))) return 'success';
    if (['P', 'E', 'R', 'S'].includes(this.getCharAtName(name))) return 'warning';
    if (['V', 'W', 'X', 'Z'].includes(this.getCharAtName(name))) return 'error';
    return 'default';
  }

  removeSpecialChars(inputString: string): string {
    // Define a regular expression to match special characters except spaces
    const regex = /[^a-zA-Z0-9 ]/g;

    // Use replace method to remove special characters
    const result = inputString.replace(regex, '');

    return result;
  }

  userNameInicials(): string {
    if (this.userName != null) {
      const names = this.removeSpecialChars(this.userName.trim()).split(' ');
      const firstName = names[0];
      if(names.length == 1) return firstName.slice(0, 2).toUpperCase();

      const lastName = names[names.length - 1];
      return firstName[0]?.toUpperCase() + lastName[0]?.toUpperCase();
    }
    return '';
  }
}
